import { get } from 'services/api/base-portal-api';

import { LatestProductsResponse } from 'types/latest-products';

export function getMerchantLatestProducts(count: number): Promise<LatestProductsResponse> {
  return get(`v1/Merchants/latest-products?size=${count}`).json();
}
